module.exports = __webpack_public_path__ + "img/bg9.4230b2d9.png";